import React from "react";
import "./ErrorBoundary.css";

/**
 * Catches render and lifecycle errors below it.
 *
 * Without this, a single bad component unmounts the whole tree and the user
 * gets a blank white page with no way forward - which is exactly what a
 * mistaken effect cleanup did before this existed. A contained failure that
 * still shows the navigation is far better than losing the app.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="errb" role="alert">
        <div className="errb-inner">
          <h1>Something broke on this page</h1>
          <p>
            The rest of the app is still fine. Reload, or head back to the
            generator.
          </p>
          <div className="errb-actions">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
            <a className="btn" href="/">
              Go to generator
            </a>
          </div>
          {process.env.NODE_ENV !== "production" && (
            <pre className="errb-detail">{String(error.stack || error)}</pre>
          )}
        </div>
      </div>
    );
  }
}
